export const MenuNavRoutes = {
    0: '/dms/principal/home',
    1: '/dms/general/gestion-terceros',
    2: '/dms/warehouse/home-almacen',
    3: '/dms/workshop/home-taller',
    4: '/dms/invoices/home-facturas',
    5: '/dms/connectivity/interfaces-marca',
    6: '/dms/accounting/home-contabilidad',
    7: '/dms/vc-vo/home-vo',
    8: '/dms/grc/marketing',
    9: '/dms/productivity/gestion-empleados',
    99: '/dms/panel-control/starauto',
};


